Vue.component('download-uploader', {
    props: ['textPage'],
    data() {
        return {
            dropzoneOptions: null,
        }
    },
    computed: {
        //
    },
    methods: {
        handleUploadSuccess(file, response) {
            this.eventHub.$emit('downloadAdded', response);
            this.$refs.downloadDropzone.removeFile(file);
        },
        handleUploadError() {
            //
        },
    },
    mounted() {
        var self = this;

        this.dropzoneOptions = {
                url: '/downloads',
                maxFiles: 1,
                maxFilesize: 6,
                headers: {
                    'X-CSRF-TOKEN': document.head.querySelector('meta[name="csrf-token"]').content,
                },
                dictDefaultMessage: 'Add downloads by dropping a file into this window',
                init: function() {
                    this.on('sending', function(file, xhr, formData){
                            formData.append('text_page_id', self.textPage.id);
                    });
                }
            };
    }
});